export class ExperimentFolder {
  constructor(timestamp, baseRoute, name=null, startDate=null, incubator=null, endDate=null, flagged = false) {
    this.s3Files = [];

    this.timestamp = timestamp;
    this.name = name;
    this.incubator = incubator;

    this.dataKey = baseRoute + "/remoteSummaryAnalyzed.csv";
    this.metadataKey = baseRoute + "/metadata.json";
    this.issuesKey = baseRoute + "/Issue Log.json";

    this.startDate = startDate;
    this.endDate = endDate;

    if (!isNaN(this.endDate)) {
      this.status = "Complete"
    }

    this.flagged = flagged
  }

  setFlagged(flagged) {
    this.flagged = flagged
    this.status = this.calculateRowStatus()
  }

  setEndDate(endDate) {
    this.endDate = endDate
    this.status = this.calculateRowStatus()
  }

  calculateRowStatus() {
    if (!isNaN(this.endDate)) {
      return "Complete"
    } else {
      if (this.flagged) {
        return "Flagged"
      } else {
        return "Running"
      }
    }
  }

  length() {
    if (this.endDate != null && this.startDate != null) {
      return this.endDate - this.startDate;
    } else {
      return null;
    }
  }
}
